import { icons } from '@cores/utils/workspaceIcon';
import { createSharedComposable } from '@vueuse/core';
import _ from 'lodash';
import { computed } from 'vue';
import { useSpace } from './use-space';
export const useSpaceCover = createSharedComposable(() => {
    const { spaceInfo } = useSpace();
    const spaceCover = computed(() => {
        const { space_s3_key, space_icon } = spaceInfo.value;
        return space_s3_key || _.get(icons, `${space_icon}`);
    });
    return {
        spaceCover,
    };
});
